import React, { Component } from 'react';
import Flex from '../../components/flex';
import Element from '../../components/element';
import Text from '../../components/text';
import useStyles from './style';
import GradientDivider from '../../components/gradientDivider';
import { ReactComponent as LogoSVG } from '../../assets/icons/ThorneHealthLogo.svg';


const PrivacyPolicy = () => {

    const classes = useStyles();

    const attrs = {
        width: '80%',
        margin: 'auto',
        backgroundColor: 'white',
        padding: '40px'
    };

    return (
        <Element {...attrs}>

            <Element type={LogoSVG} width="25%" />
            <GradientDivider />

            <Flex justify="space-between" align="center">
                <Element
                    type={Text}
                    attrs={{ family: 'GTAM', size: '22px' }}
                    marginBottom="15px">
                    Privacy Policy
                </Element>
            </Flex>
            <Element
                type="p"
                fontSize="18px"
                fontFamily="GTAM"
                marginTop="10px"
                margin="16px 0 !important"
            >
                HIPPA Compliance and Data Privacy
            </Element>
            <div className={classes.borderBottom}></div>

            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Information Collection
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                Protected Health Information (hereinafter “PHI”) is any information associated with an individual needed for patient care, medical diagnosis, and treatment. PHI may be stored or transmitted using paper or electronic means. HIPAA requires covered entities and business associates to protect this information from inappropriate disclosure. Electronic Protected Health Information (hereinafter “ePHI”) is any PHI processed electronically.
            </Element>

            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Regulatory Compliance
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                The Mobile App complies with all applicable HIPAA regulations required of a covered entity and business associate. The Thorne Labs solution and associated service provide protection of a patient’s PHI and any ePHI in terms of the HIPAA Security, Privacy, and Breach Notification Rule.
            </Element>

            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Privacy
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                Data Collection and Storage of any information collected by Thorne Labs solution is fully encrypted (SHA 256) at rest and in motion.
            </Element>
            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Permission
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                Covered entities (Licensees) will obtain patient permission before collecting PHI and provide the patient with required HIPAA notifications.
            </Element>
            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Data Minimization
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                Thorne Labs only collects information required for all stated diagnostic tests. See Section <strong>Regulatory Compliance</strong> above.
            </Element>

            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Your Information, Your Rights, and Our Responsibilities
            </Element>
            <Element fontFamily="GTAR" fontSize="14px">
                A summary and detailed list of these policies may be found at Thorne Labs. However, the following summarizes our obligations to covered entities and their patients.
            </Element>

            <Element marginLeft="10px">
                <Element
                    type="p"
                    fontSize="16px"
                    fontFamily="GTAM"
                    margin="16px 0 !important">
                    Protection of Patient Rights
                </Element>
                <Element fontFamily="GTAR" fontSize="14px">
                    Thorne Labs will protect your patient’s rights and allow patients to:
                </Element>
                <Element>
                    <Element type="ul" className={classes.listStyle} fontSize="14px">
                        <Element>
                            <Element type="li" fontSize="14px">
                                Obtain an electronic copy of your medical records.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    The solution can produce an electronic or paper copy of the patient’s medical records and other health information.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    The solution will create this report on demand for any health information collected by the Thorne Labs solution.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Ask Us to Correct the patient’s medical records.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    Patients may ask us to correct any health information we collect that the patient confirms is incorrect.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    We may say no but will provide the reason(s) within sixty (60) days.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Request Confidential Communications
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    The patient can ask us to contact them using a specific method of their choice, including United States Mail, SMS text message, FAX, and email with a HIPAA-compliant file sharing capability.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    We will say yes to all reasonable patient communication requests.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Ask us to limit what information we use and share.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    Patients can ask us not to use or share certain health information for treatment or payment purposes. (We may disagree with the patient’s request if this would negatively affect the patient’s care.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    If the patient pays for any service “out-of-pocket” in full, the patient may request that this information be held confidential and not shared with the patient’s health insurer unless the law requires us to share the information with the insurer.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Get a List of those with whom we shared information.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    The patient can ask for a list (accounting) with whom we shared the patient’s information and why for six years before the date of request.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    These reports will include all receiving entities' names and the provided information except for treatment, payments, and certain disclosures the patient asks us to make.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    We will provide one free accounting per year but will charge a reasonable cost-based fee for additional reports within the same 12-month period.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Choose someone to act on the patient’s behalf.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    If the patient grants medical power of attorney (hereinafter “mPOA”) or has a legal guardian, that person may act on the patient’s behalf.
                                </Element>
                                <Element type="li" fontSize="14px">
                                    We will ensure that the person can request information on the patient’s behalf.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                Get a copy of this privacy notice.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    The patient or mPOA can ask for a paper copy of this notice at any time, even if the patient or mPOA agreed to receive all notifications electronically. We will process these requests promptly.
                                </Element>
                            </Element>
                        </Element>

                        <Element>
                            <Element type="li" fontSize="14px">
                                File a complaint if the patient feels their rights are violated.
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px" whiteSpace="pre-line">
                                    Patients can complain if they feel the Covered Entity or Thorne Labs as the covered entity’s business associate, violated their rights. Complaints may be filed with:
                                    {"\n\t"}    The U.S. Department of Health and Human Services Office for Human Rights
                                    {"\n\t"}    200 Independence Avenue S. W.
                                    {"\n\t"}    Washington, DC 202201
                                    {"\n\t"}    (877) 696-6775
                                    {"\n\t"}    <a href='http://www.hhs.gov/ocr/privacy/hipaa/complaints'>www.hhs.gov/ocr/privacy/hipaa/complaints</a>
                                </Element>
                                <Element type="li" fontSize="14px">
                                    We will not retaliate against the patient or their mPOA
                                </Element>
                            </Element>
                        </Element>

                    </Element>
                </Element>

                <Element
                    type="p"
                    fontSize="16px"
                    fontFamily="GTAM"
                    margin="16px 0 !important">
                    Patient Choice for Information Sharing
                </Element>
                <Element>
                    <Element type="ul" className={classes.listStyle} fontSize="14px">
                        <Element>
                            <Element type="li" fontSize="14px">
                                Patients or the mPOA can direct us to share certain health information with family, close friends, or others and share information in a disaster relief situation or share information in a hospital directory. Note: If the patient cannot tell us their preferences, we may disclose PHI if we feel it is in the patient’s best interest.
                            </Element>
                        </Element>
                    </Element>
                </Element>

                <Element
                    type="p"
                    fontSize="16px"
                    fontFamily="GTAM"
                    margin="16px 0 !important">
                    Information Sharing Requiring Explicit Patient Permission
                </Element>
                <Element>
                    <Element type="ul" className={classes.listStyle} fontSize="14px">
                        <Element>
                            <Element type="li" fontSize="14px">
                                We will never share information without explicit patient approval for:
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    Marketing
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Sales of the patient’s information
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Psychotherapy notes
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Fundraising
                                </Element>
                            </Element>
                        </Element>
                    </Element>
                </Element>

                <Element
                    type="p"
                    fontSize="16px"
                    fontFamily="GTAM"
                    margin="16px 0 !important">
                    Other Uses and Disclosures
                </Element>
                <Element>
                    <Element type="ul" className={classes.listStyle} fontSize="14px">
                        <Element>
                            <Element type="li" fontSize="14px">
                                We will share a patient’s PHI to:
                            </Element>
                            <Element type="ul" className={classes.childListStyle}>
                                <Element type="li" fontSize="14px">
                                    Provide Treatment
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Run our organization
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Bill for our services
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Aid public health and safety
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Perform medical research
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Legal compliance
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Respond to organ and tissue donation requests
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Work with a medical examiner or funeral director
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Address worker’s compensation, law enforcement, and government requests
                                </Element>
                                <Element type="li" fontSize="14px">
                                    Respond to lawsuits and legal action
                                </Element>
                            </Element>
                        </Element>
                    </Element>
                </Element>

                <Element
                    type="p"
                    fontSize="16px"
                    fontFamily="GTAM"
                    margin="16px 0 !important">
                    Thorne Labs Responsibilities
                </Element>
                <Element>
                    <Element type="ul" className={classes.listStyle} fontSize="14px">
                        <Element>
                            <Element type="li" fontSize="14px">
                                We are required by law to maintain the privacy and security of the patient’s PHI.
                            </Element>
                            <Element type="li" fontSize="14px">
                                We will let the patient know promptly if a breach occurs that may have compromised the privacy or security of the patient’s information.
                            </Element>
                            <Element type="li" fontSize="14px">
                                We must follow the duties and privacy practices described in this notice and give you a copy of it.
                            </Element>
                            <Element type="li" fontSize="14px">
                                We will not use or share the patient’s information other than as described here unless the patient tells us we can in writing. If you tell us we can, the patient may change their mind anytime.
                            </Element>
                            <Element type="li" fontSize="14px" whiteSpace="pre-line">
                                Patients need to inform us in writing if they change their minds. For more information,
                                {"\n"}see: <a href='http://www.hhs.gov/ocr/privacy/hipaa/understanding/consumers/noticepp.htm'>www.hhs.gov/ocr/privacy/hipaa/understanding/consumers/noticepp.htm</a>
                            </Element>
                        </Element>
                    </Element>
                </Element>
            </Element >

            <Element
                type="p"
                fontSize="18px"
                fontFamily="GTAM"
                marginTop="10px"
                margin="16px 0 !important"
            >
                Privacy Collection and Use of Certain Information
            </Element>
            <div className={classes.borderBottom}></div>
            <Element
                type="p"
                fontSize="16px"
                fontFamily="GTAM"
                margin="16px 0 !important"
            >
                Passwords
            </Element>
            <Element fontFamily="GTAR" fontSize="14px" whiteSpace="pre-line">
                When this Agreement has been accepted and agreed to by you, the password that you create will soon be activated and enable you to access your Account for access to the Mobile App. Passwords may not be shared or used by more than one individual. Any transfer of passwords to, or use of passwords by, an unauthorized person is strictly prohibited. You will maintain the confidentiality of the User IDs and passwords by which you access the Mobile App and will allow access to the Mobile App only by authorized persons, and not by any program, expert system, electronic agent, "bot" or other automated means. You acknowledge that neither Thorne HealthTech nor any third party will contact you to solicit your User ID, or password. Therefore, you should not provide your User ID or password to any person whom you do not authorize to use your Account. Any use of your assigned user IDs or passwords will be deemed to be your use. Remember to choose a strong password, including numbers, capital letters, special characters, etc., and one that is not typically found in a dictionary. You may never use someone else’s account, username, or password without permission. When creating your Account, you must provide accurate and complete information. In the event your password is lost or stolen it is your responsibility to notify Thorne HealthTech as provided in with the contact information included with your license agreement – the Thorne HealthTech Lab.  Email @ thornelabs4help@thorne.com.

                {"\n\n"}YOU ARE RESPONSIBLE FOR MAINTAINING THE CONFIDENTIALITY OF YOUR PASSWORD AND ACCOUNT, AND YOU AGREE THAT YOU ARE FULLY RESPONSIBLE FOR ALL ACTIVITIES THAT OCCUR UNDER YOUR PASSWORD OR ACCOUNT, AND THAT THORNE HEALTHTECH HAS NO LIABILITY FOR ANY ACTIVITIES THAT OCCUR UNDER YOUR PASSWORD OR ACCOUNT.

                {"\n\n"}If you become aware of any breach of security through your Account, you must immediately change your password and notify us of such breach. You agree that, unless you have first notified us immediately of any such breach, we should assume that any instruction transmitted using your User ID and password is yours and has been authorized by you, and we will have no obligation to inquire into the propriety of such instruction. You will not permit any use of the Mobile App that would damage, interfere with, or unreasonably overload the Mobile App.
            </Element>

        </Element>
    )
}


export default PrivacyPolicy
